<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block rounded color="info" v-on="on" v-bind="attrs">Editar</v-btn>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold green lighten-4 primary--text"
        >Editar Contato {{ dadosContato.numcontato }}</v-card-title
      >
      <v-card-text>
        <v-form class="mt-4" ref="form">
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="DDD"
                v-model="ddd"
                v-mask="'##'"
                :rules="[(v) => v.length == 2 || 'DDD Inválido']"
                :disabled="infcodigosms"
              ></v-text-field>
            </v-col>
            <v-col cols="9">
              <v-text-field
                label="Telefone"
                v-mask="'#########'"
                v-model="telefone"
                :rules="[
                  (v) =>
                    v.length > 7 || 'Informe corretamente o número de telefone',
                ]"
                :disabled="infcodigosms"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-btn
                color="success"
                depressed
                dark
                rounded
                block
                @click="confirmarContato()"
                :loading="confirmando"
                v-if="!infcodigosms"
                >Confirmar</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="infcodigosms" dense>
            <v-col cols="12" class="pb-0">
              <v-alert type="success" text
                >Código SMS enviado com sucesso</v-alert
              >
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-card elevation="0" color="grey lighten-3">
                <v-card-title class="font-weight-bold"
                  >Informe o código recebido via SMS</v-card-title
                >
                <v-card-text class="pb-0">
                  <v-form>
                    <v-text-field
                      label="Código SMS Recebido"
                      v-model="codigosms"
                      id="sms-recebido"
                      v-mask="'######'"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    rounded
                    block
                    color="success"
                    @click="confirmarCodigoSms()"
                    :loading="validando"
                    >Confirmar código</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions, mapMutations } from "vuex";
export default {
  props: {
    dadosContato: Object,
  },
  watch: {
    dialog: function (open) {
      if (open) {
        this.infcodigosms = false;
        this.codigosms = "";
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
        this.ddd = this.dadosContato.ddd;
        this.telefone = this.dadosContato.telefone;
      }
    },
  },
  data: () => ({
    dialog: false,
    ddd: "",
    telefone: "",
    confirmando: false,
    codigosms: "",
    infcodigosms: false,
    validando: false,
  }),
  methods: {
    ...mapMutations("atualizacaoCadastral", ["setCarregando"]),
    ...mapActions("atualizacaoCadastral", ["getDadosCadastrais"]),
    async confirmarContato() {
      this.confirmando = true;

      var data = JSON.stringify({
        contato: this.dadosContato.numcontato,
        ddd: this.ddd.toString(),
        telefone: this.telefone.toString(),
      });

      await axios
        .post("/colaborador/atualizacao-cadastral", data, {
          params: { funcao: "VALIDAR-CONTATO" },
        })
        .then(async (res) => {          
          if (res.data.success) {
            if (res.status == 201) {
              this.dialog = false;
              this.$toasted.success(res.data.msg);
              await this.atualizarTela();
            } else {
              this.infcodigosms = true;
            }
          } else {
            this.$toasted.error(res.data.msg);
          }
        })
        .catch((e) => this.$toasted.error(e))
        .finally(() => (this.confirmando = false));
    },
    async confirmarCodigoSms() {
      if (this.codigosms.length != 6) {
        this.$toasted.error("Informe corretamente o código recebido via SMS");
        return;
      }
      this.validando = true;

      await axios
        .post(
          "/colaborador/atualizacao-cadastral",
          JSON.stringify({
            contato: this.dadosContato.numcontato,
            codigo: this.codigosms,
          }),
          {
            params: {
              funcao: "CONFIRMAR-CODIGO",
            },
          }
        )
        .then(async (res) => {
          if (res.data.success) {
            this.$toasted.success(res.data.msg);
            this.validando = false;
            this.dialog = false;
            await this.atualizarTela()
          } else {
            this.$toasted.error(res.data.msg);
          }
        })
        .catch((e) => this.$toasted.error(e))
        .finally(() => (this.validando = false));
    },
    async atualizarTela() {
      this.setCarregando(true);
      await this.getDadosCadastrais();
      this.setCarregando(false);
    },
  },
};
</script>

<style>
#sms-recebido {
  letter-spacing: 15px !important;
}
</style>